/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpProtectedResourceMetadataResponse
 */
export interface McpProtectedResourceMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof McpProtectedResourceMetadataResponse
     */
    resource: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof McpProtectedResourceMetadataResponse
     */
    authorizationServers: Array<string>;
    /**
     * 
     * @type {Array<McpProtectedResourceMetadataResponseScopesSupportedEnum>}
     * @memberof McpProtectedResourceMetadataResponse
     */
    scopesSupported: Array<McpProtectedResourceMetadataResponseScopesSupportedEnum>;
    /**
     * 
     * @type {Array<McpProtectedResourceMetadataResponseBearerMethodsSupportedEnum>}
     * @memberof McpProtectedResourceMetadataResponse
     */
    bearerMethodsSupported: Array<McpProtectedResourceMetadataResponseBearerMethodsSupportedEnum>;
}


/**
 * @export
 */
export const McpProtectedResourceMetadataResponseScopesSupportedEnum = {
    McpRead: 'mcp:read'
} as const;
export type McpProtectedResourceMetadataResponseScopesSupportedEnum = typeof McpProtectedResourceMetadataResponseScopesSupportedEnum[keyof typeof McpProtectedResourceMetadataResponseScopesSupportedEnum];

/**
 * @export
 */
export const McpProtectedResourceMetadataResponseBearerMethodsSupportedEnum = {
    Header: 'header'
} as const;
export type McpProtectedResourceMetadataResponseBearerMethodsSupportedEnum = typeof McpProtectedResourceMetadataResponseBearerMethodsSupportedEnum[keyof typeof McpProtectedResourceMetadataResponseBearerMethodsSupportedEnum];


/**
 * Check if a given object implements the McpProtectedResourceMetadataResponse interface.
 */
export function instanceOfMcpProtectedResourceMetadataResponse(value: object): value is McpProtectedResourceMetadataResponse {
    if (!('resource' in value) || value['resource'] === undefined) return false;
    if ((!('authorizationServers' in (value as Record<string, any>)) && !('authorization_servers' in (value as Record<string, any>))) || ((value as Record<string, any>)['authorizationServers'] === undefined && (value as Record<string, any>)['authorization_servers'] === undefined)) return false;
    if ((!('scopesSupported' in (value as Record<string, any>)) && !('scopes_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['scopesSupported'] === undefined && (value as Record<string, any>)['scopes_supported'] === undefined)) return false;
    if ((!('bearerMethodsSupported' in (value as Record<string, any>)) && !('bearer_methods_supported' in (value as Record<string, any>))) || ((value as Record<string, any>)['bearerMethodsSupported'] === undefined && (value as Record<string, any>)['bearer_methods_supported'] === undefined)) return false;
    return true;
}

export function McpProtectedResourceMetadataResponseFromJSON(json: any): McpProtectedResourceMetadataResponse {
    return McpProtectedResourceMetadataResponseFromJSONTyped(json, false);
}

export function McpProtectedResourceMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpProtectedResourceMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'resource': json['resource'],
        'authorizationServers': json['authorization_servers'],
        'scopesSupported': json['scopes_supported'],
        'bearerMethodsSupported': json['bearer_methods_supported'],
    };
}

export function McpProtectedResourceMetadataResponseToJSON(json: any): McpProtectedResourceMetadataResponse {
    return McpProtectedResourceMetadataResponseToJSONTyped(json, false);
}

export function McpProtectedResourceMetadataResponseToJSONTyped(value?: McpProtectedResourceMetadataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resource': value['resource'],
        'authorization_servers': value['authorizationServers'],
        'scopes_supported': value['scopesSupported'],
        'bearer_methods_supported': value['bearerMethodsSupported'],
    };
}

